interface Props {
  size?: number;
  className?: string;
}

/**
 * Line-style shopping cart, drawn in `currentColor` so it stays legible on the
 * filled cart button (the 🛒 emoji is grey and disappears on the primary fill).
 */
export const CartIcon = ({ size = 20, className }: Props): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={className}
  >
    <circle cx="9" cy="20" r="1.5" />
    <circle cx="18" cy="20" r="1.5" />
    <path d="M2.5 3h2.5l2.4 11.2a2 2 0 0 0 2 1.6h8.3a2 2 0 0 0 2-1.5L21.5 7H6" />
  </svg>
);
